// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-TAB":"E_TAB_outdoor-recreation-TAB__bgB56"};